import type { IButtonIcon } from './ButtonIcon';

import ButtonIcon from './ButtonIcon';

export type { IButtonIcon };
export default ButtonIcon;
